export const questionsObject = {
    questionData: null,
    isLoading: false,
    error: null,
    selectedSection: null,
};
